import { Injectable } from '@angular/core';

@Injectable()
export class WebLiveUpdateService {
  public handleSync() {
    // reload page or ??
    window?.location?.reload();
  }
}
